import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tab } from '@shared';
import { reportTypes } from '../../constants';

@Component({
  selector: 'app-exceptions',
  templateUrl: './exceptions.component.html',
  styleUrl: './exceptions.component.scss',
})
export class ExceptionsComponent {
  selectedTabIndex: number = 0;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  tabs: Tab[] = Array.from(reportTypes.keys()).map((rt) => {
    return new Tab(rt, `${reportTypes.get(rt)}`);
  });

  onTabSelect(selectedTab: Tab) {
    this.selectedTabIndex = this.tabs.indexOf(selectedTab);

    this.tabs.forEach((tab) => {
      tab.selected = tab.name === selectedTab.name;
    });

    this.router.navigate([selectedTab?.contentUrl], {
      relativeTo: this.activatedRoute,
    });
  }
}
